import type { HistoryEntry, Measurement } from "../types.ts";

export function measuredCents(valueCents: number, percent: number): number {
	return Math.floor((valueCents * percent + 50) / 100);
}

function newestFirst(a: HistoryEntry, b: HistoryEntry): number {
	if (a.measuredOn !== b.measuredOn) {
		return a.measuredOn < b.measuredOn ? 1 : -1;
	}
	return (a.stageItemNumber ?? "").localeCompare(
		b.stageItemNumber ?? "",
		undefined,
		{ numeric: true },
	);
}

export function buildHistory(
	measurements: Measurement[],
	valueByStage?: ReadonlyMap<string, number>,
): HistoryEntry[] {
	const byLeaf = new Map<string, Measurement[]>();
	for (const measurement of measurements) {
		const leaf = byLeaf.get(measurement.stageId) ?? [];
		leaf.push(measurement);
		byLeaf.set(measurement.stageId, leaf);
	}

	const entries: HistoryEntry[] = [];
	for (const [stageId, leaf] of byLeaf) {
		const value = valueByStage?.get(stageId);
		const ordered = [...leaf].sort((a, b) =>
			a.measuredOn.localeCompare(b.measuredOn),
		);
		let previousPercent = 0;
		for (const measurement of ordered) {
			const entry: HistoryEntry = {
				...measurement,
				measuredCents: undefined,
				percentDelta: measurement.progressPercent - previousPercent,
			};
			if (value !== undefined) {
				entry.measuredCents = measuredCents(value, measurement.progressPercent);
				entry.centsDelta =
					entry.measuredCents - measuredCents(value, previousPercent);
			}
			entries.push(entry);
			previousPercent = measurement.progressPercent;
		}
	}

	return entries.sort(newestFirst);
}
